import FlexBox from 'components/Shared/Container/FlexBox';
import React from 'react';
import { styled } from 'styled-components';
import Marker from '../Map/Marker/Marker';
import { convertHexToRGBA } from 'utils/color';
import { getPrimaryImage } from 'utils/supplyChain';
import Icon from 'components/Shared/Icon/Icon';
import { SiteType } from 'types/site.types';
import { useTranslation } from 'react-i18next';
const BackgroundContainer = styled(FlexBox) `
  padding: 16px;
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
  border-radius: 6px;
  background: ${({ theme }) => theme.palette.grey[10]};
`;
const HeaderTextContainer = styled.div `
  color: ${({ hasMedia, theme }) => hasMedia ? '#000' : theme.palette.grey['A800']};
  width: 100%;
  overflow: hidden !important;
`;
const Location = styled.div `
  line-height: 1;
  font-weight: 300;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const OutputComponent = styled.div `
  display: inline-flex;
  padding: 4px 8px;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadiusButton};
  background: ${convertHexToRGBA('#ffffff', 0.8)};
  color: ${({ theme }) => theme.palette.grey.A800};
  box-shadow: ${({ theme }) => theme.shadows[0]};
  font-weight: 700;
  height: 28px;
  font-size: 14px;
`;
export const HeaderContainer = styled.div `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
`;
const StyledMarker = styled(Marker) `
  transform: scale(0.7);
`;
const Title = styled.div `
  font-size: 16px !important;
  font-weight: 800 !important;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const ClusterTag = styled(FlexBox) `
  white-space: nowrap;
  overflow: hidden;
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-overflow: ellipsis;
`;
const TotalValue = styled(FlexBox) `
  color: ${({ theme }) => theme.palette.grey.A800};
  font-family: Lato;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  overflow: hidden;
`;
const TotalFarmerlabel = styled.span `
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const Header = ({ activity, isActive }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const nodeHasMedia = !!((_a = activity === null || activity === void 0 ? void 0 : activity.mediaList) === null || _a === void 0 ? void 0 : _a.length);
    const { t } = useTranslation();
    return (React.createElement(BackgroundContainer, { m: 2 },
        React.createElement(HeaderContainer, null,
            !!activity && (React.createElement(StyledMarker, { image: getPrimaryImage(activity.mediaList), renderedOn: "NODE", active: isActive })),
            React.createElement(HeaderTextContainer, { hasMedia: nodeHasMedia },
                React.createElement(FlexBox, { gap: 1, pt: 1 },
                    React.createElement(Title, null, activity.title),
                    ((_b = activity.site) === null || _b === void 0 ? void 0 : _b.siteType) === SiteType.CLUSTER && (React.createElement(ClusterTag, { gap: 0.5 },
                        React.createElement(Icon, { name: "farm", size: "large" }),
                        `${activity.site.sites.count} ${((_d = (_c = activity.site.sites.edges[0]) === null || _c === void 0 ? void 0 : _c.node) === null || _d === void 0 ? void 0 : _d.siteType) === SiteType.FARM ? t('farms') : t('sites')}`))),
                React.createElement(Location, null, activity.site.locationName))),
        React.createElement(FlexBox, { gap: 1, flexWrap: "wrap" },
            activity.component && (React.createElement(OutputComponent, null, activity.component.title)),
            ((_e = activity.site) === null || _e === void 0 ? void 0 : _e.siteType) === SiteType.CLUSTER &&
                ((_g = (_f = activity.site) === null || _f === void 0 ? void 0 : _f.sitesSummary) === null || _g === void 0 ? void 0 : _g.workersAmount) > 0 && (React.createElement(TotalValue, { gap: 1 },
                React.createElement(Icon, { name: "group", size: "large" }),
                React.createElement(TotalFarmerlabel, null, `${((_j = (_h = activity.site) === null || _h === void 0 ? void 0 : _h.sitesSummary) === null || _j === void 0 ? void 0 : _j.workersAmount) || 0} ${t('tracing.total-farmers')}`))))));
};
export default Header;
